<template>
  <h2
    v-if="subheadingText"
    :class="subheadingClasses"
    v-html="subheadingText"
  />
</template>

<script>
export default {
  name: 'Subheading',

  props: {
    subheadingObj: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    // Subheading
    subheadingClasses() {
      const { subheadingObj } = this
      const fontFamily = subheadingObj.font_family ?? 'body'
      return [
        // Margin
        'mt-8',
        // Color
        `text-${subheadingObj.text_color ?? 'white'}`,
        // Size
        'text-xl lg:text-2xl',
        // Family
        `font-${fontFamily}`,
        // Weight
        `font-${fontFamily}-${subheadingObj.font_weight ?? 'normal'}`,
        // Transform
        subheadingObj.text_transform ?? 'normal-case'
      ]
    },
    subheadingText() { return this.subheadingObj.subheading_text }
  }
}
</script>

